import ContactUsList from "../components/ContactUsList";

const ListContactUsPage = () => {
  return (
    <ContactUsList />
  );
};

export default ListContactUsPage;
